import { useSelector } from '@xstate/react'
import { useContext } from 'react'
import { SessionContext } from './context/SessionProvider'

export const useCurrentUser = () => {
  const { sessionService } = useContext(SessionContext)
  const user = useSelector(sessionService, (state) => state.context.user)
  const sessionIsInitialized = useSelector(sessionService, (state) => state.matches('loggedIn') || state.matches('unidentified'))
  const isLoggedIn = useSelector(sessionService, (state) => state.matches('loggedIn'))
  const ability = useSelector(sessionService, (state) => state.context.ability)

  return {
    user,
    sessionIsInitialized,
    isLoggedIn,
    ability
  }
}
